import { render, staticRenderFns } from "./ConceptDangerZones.vue?vue&type=template&id=803338ba&scoped=true"
import script from "./ConceptDangerZones.vue?vue&type=script&lang=ts"
export * from "./ConceptDangerZones.vue?vue&type=script&lang=ts"
import style0 from "./ConceptDangerZones.vue?vue&type=style&index=0&id=803338ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "803338ba",
  null
  
)

export default component.exports